// @flow

export const DIRECTION = [
  { label: '<=>', value: '<=>' },
  { label: '=>', value: '=>' }
];

// Display 10 suggestions per page
export const NUMBER_SYNONYMS_PER_PAGE = 10;

export const SynonymType = {
  MANUAL: 'synonym',
  AI: 'ai-synonym'
};
